import { AxiosError } from 'axios';
import { showNotification } from 'helper/common/commonFunctions';
import { IErrorResponse } from 'interface/apiInterface';

// auth
export const loginEP = '/auth/email_token';
export const loginVerifyEP = '/auth/validate_email_token';
export const refreshTokenEP = '/auth/refresh_token';

// users
export const getUsersPermissionEP = '/my/permissions';
export const getAllUsersEP = '/admin/all-users';
export const createAdminUsersEP = 'admin/invite';
export const updateAdminUsersEP = 'admin/permissions';
export const sendInviteEP = '/users/invite';
export const reSendInviteEP = '/users/invite/resend';
export const updateUsersPermissionEP = '/users/permissions';

// apps
export const listAppsEP = '/apps/list';
export const getAppEP = '/apps/get';

// stages
export const listStagesEP = '/slices/list'; // TODO: change to stages when backend is ready
export const getStageEP = '/slices/get'; // TODO: change to stages
// pull requests
export const searchPullRequestEP = '/pull_requests/search';
export const getPRStatsEP = '/pull_requests/stats';

// issues
export const searchIssueEP = '/issues/search';

// github
export const createGithubUserEP = '/github/user/create';

// organizations
export const createOrganizationEP = '/organization';
export const listOrganizationsForUserEP = '/my/organizations';

// installations
export const createInstallationEP = '/installations/create';

// repositories
export const listRepositoriesEP = '/repositories/list';
export const listMyRepositoriesEP = '/my/repositories';
export const addRepoToOrganizationEP = '/repositories/add';
export const deleteRepositoryEP = '/repositories/delete';

// repository settings
export const getRepositorySettingsEP = '/repository_settings';
export const updateRepositorySettingsEP = '/repository_settings/update';

// workflows
export const searchWorkFlowsEP = '/workflow_runs/search';
export const getWorkflowRunEP = '/workflow_runs/get';
export const getWorkflowRunStepsEP = '/workflow_runs/steps';
export const getWorkflowRunLogsEP = '/workflow_runs/logs';
export const resumeWorkflowEP = '/workflow_actions/resume';
export const pauseWorkflowEP = '/workflow_actions/pause';
export const cancelWorkflowEP = '/workflow_actions/cancel';
export const archiveWorkflowEP = '/workflow_actions/archive';

// secrets
export const createSecretEP = '/secrets/create';
export const updateSecretEP = '/secrets/update';
export const deleteSecretEP = '/secrets/delete';
export const searchSecretsEP = '/secrets/search';

// deployment
export const listDeploymentVersionsEP = '/deployment_versions/list';
export const getDeploymentVersionEP = '/deployment_versions/get';

// subscriptions
export const getRetentionReportLifeTimeEP =
  '/subscriptions/reports/retention/cycle/lifetime';

// clusters
export const editClusterEP = '/clusters/edit';
export const deleteClusterEP = '/clusters/delete';
export const getClusterEP = '/clusters/get';
export const listClustersEP = '/clusters/list';

export const getUsersPermissions = (userId: string) => {
  return `/admin/${userId}/permissions`;
};

export const getGrantSuperAdminEP = (user_id: string) => {
  return '/users/' + user_id + '/grant_super_admin';
};
export const getRevokeSuperAdmin = (user_id: string) => {
  return '/users/' + user_id + '/revoke_super_admin';
};

export const publicEndpoints = [loginEP, loginVerifyEP, refreshTokenEP];

const errorMessages: {
  [_: number]: {
    status: number;
    message: string;
  };
} = {
  400: {
    status: 400,
    message:
      'The server could not understand the request due to invalid syntax.',
  },
  401: {
    status: 401,
    message:
      'You are not authorized to access this resource. Please authenticate yourself.',
  },
  403: {
    status: 403,
    message: 'You do not have permission to access this resource.',
  },
  404: {
    status: 404,
    message: 'The page you requested could not be found.',
  },
  500: {
    status: 500,
    message:
      'An unexpected error occurred on the server. Please try again later.',
  },
  502: {
    status: 502,
    message: 'The server received an invalid response from an upstream server.',
  },
  503: {
    status: 503,
    message:
      'The server is currently unable to handle the request due to temporary overloading or maintenance of the server. Please try again later',
  },
  504: {
    status: 504,
    message:
      'The server did not receive a timely response from an upstream server.',
  },
  408: {
    status: 408,
    message:
      'The server did not receive a complete request within the time that it was prepared to wait.',
  },
  425: {
    status: 425,
    message:
      'The server is unwilling to risk processing a request that might be replayed.',
  },
  429: {
    status: 429,
    message:
      'You have made too many requests in a given amount of time. Please try again later.',
  },
};

export const except = 'ERR_CANCELED';

export const commonError = (
  error: AxiosError,
  showErrorNotification: boolean = false,
): IErrorResponse<AxiosError> => {
  if (error.isAxiosError && error.response) {
    if (error?.code !== except && showErrorNotification) {
      const response = error?.response?.data as {
        Msg: string;
        StatusCode: number;
      };
      const message =
        response?.Msg ||
        errorMessages?.[error.response?.status]?.message ||
        'Internal Server Error';
      showNotification('failed', message);
    }
    return { status: error?.status as number, message: error.message, error };
  } else {
    if (error?.code !== except && showErrorNotification)
      showNotification('failed', error.message);
    return { status: error?.status as number, message: error.message, error };
  }
};
